import { createAction, props } from '@ngrx/store';
import { UnitApiModel } from 'app/models/units-api.model';

export const loadUnits = createAction('[Units] Load');

export const loadUnitsSuccess = createAction(
  '[Units] Load Successful',
  props<{ response: UnitApiModel[] }>()
);

export const loadUnitsFailed = createAction(
  '[Units] Load Failed',
  props<{ error: any }>()
);

export const createUnit = createAction(
  '[Unit] Create',
  props<{ unit: UnitApiModel }>()
);

export const createUnitSuccess = createAction('[Unit] Create Successful');

export const createUnitFailed = createAction(
  '[Unit] Create Failed',
  props<{ error: any }>()
);

export const updateUnit = createAction(
  '[Unit] Update',
  props<{ unit: UnitApiModel }>()
);

export const updateUnitSuccess = createAction('[Unit] Update Successful');

export const updateUnitFailed = createAction(
  '[Unit] Update Failed',
  props<{ error: any }>()
);

export const deleteUnits = createAction(
  '[Unit] Delete',
  props<{ unit: UnitApiModel[] }>()
);

export const deleteUnitsSuccess = createAction('[Units] Delete Successful');

export const deleteUnitsFailed = createAction(
  '[Units] Delete Failed',
  props<{ error: any }>()
);

export const resetUnits = createAction('[Units] Reset');
